import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Select from '@material-ui/core/Select'
import InputBase from '@material-ui/core/InputBase'
import { ResetIcon } from '../../app-icon/Icons'

const styles = theme => ({
  root: {
    width: '100%',
    borderRadius: 4,
  },
  formControl: {
    position: 'relative',
    width: '100%',
  },
  icon: {
    top: 'calc(50% - 19px)',
    right: 8,
  },
  outlined: {
    borderRadius: 4,
    border: 'solid 1px rgb(187, 187, 187)',
  },
  select: {
    '&:focus': {
      borderRadius: 4,
      border: 'solid 1px #9371ff',
      backgroundColor: '#fff',
    },
  },
  btnFieldClear: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 12px',
    margin: 0,
    position: 'absolute',
    top: 10,
    right: 0,
    cursor: 'pointer',
    border: 0,
    backgroundColor: 'transparent',
    outline: 'none',
    transform: 'translateX(100%)',
  },
})

const Input = withStyles(theme => ({
  input: {
    color: 'rgb(0, 0, 0)',
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#fff',
    border: 'solid 1px rgb(187, 187, 187)',
    fontSize: 16,
    width: 288,
    marginBottom: 16,
    padding: '12px 30px 11px 20px',
    transition: theme.transitions.create(['border']),
    '&:focus': {
      borderRadius: 4,
      border: 'solid 1px #9371ff',
    },
  },
}))(InputBase)

class SelectWithClear extends React.Component {
  state = {}

  render() {
    const {
      input,
      label,
      meta,
      children,
      classes,
      handleResetField,
      ...custom
    } = this.props

    return (
      <div className={classes.formControl}>
        <Select
          {...input}
          variant="outlined"
          displayEmpty
          input={<Input />}
          classes={{
            root: classes.root,
            icon: classes.icon,
            outlined: classes.outlined,
            disabled: classes.disabled,
            select: classes.select,
            selectMenu: classes.selectMenu,
          }}
        >
          {children}
        </Select>
        {input.value && (
          <button
            className={classes.btnFieldClear}
            type="button"
            onClick={() => handleResetField(input.name)}
          >
            <ResetIcon width={16} height={16} stroke={'#ff2d55'} />
          </button>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(SelectWithClear)
